import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Logo from "../assets/img/skor-white-logo.svg";
import Cancelimg from "../assets/img/cancel-01.svg";
import AuthContext from "../context/auth/AuthContext";
import { useContext, useRef, useState, useEffect } from "react";
import { getAccountName, haveValue, toast } from "../helper/common";
import constants from "../Utils/constants";
import StopSharingModal from "../components/StopSharingModal/StopSharingModal";
import useTranslator from "../hooks/useTranslator";
import "./Header.css";
import { Modal } from "react-bootstrap";
import i18next from "i18next";
import ShareProfileModal from "../components/ShareProfileModal";
import TenantContext from "../context/tenant/TenantContext";
import ApplicationContext from "../context/application/ApplicationContext";
import axiosInstance from "../services/authWrapper";
import TopUpCreditModal from "../components/TopUpCreditModal";
import InviteTenantModal from "../components/InviteTenantModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../Utils/workspaceRoleCapabilities";
import {
  RowButton,
  Avatar,
  Badge,
  Button,
  Icon,
  LanguageSwitch,
  Menu,
  Modal as DsModal,
  NavTab,
  NavTabs,
} from "../components/design";

// One tab of the phone bottom bar: icon (with an optional count on its
// corner) above a short label.
const MobileTab = ({
  icon,
  label,
  active,
  count = 0,
  className = "",
  onClick,
}) => (
  <RowButton
    type="button"
    className={`mobileTabs__item ${active ? "is-active" : ""} ${className}`.trim()}
    aria-current={active ? "page" : undefined}
    onClick={onClick}
  >
    <span className="mobileTabs__icon">
      <Icon name={icon} size={22} />
      {count > 0 && (
        <Badge tone="danger" className="mobileTabs__count">
          {count}
        </Badge>
      )}
    </span>
    <span className="mobileTabs__label">{label}</span>
  </RowButton>
);

// onOpenMenu: set by Homepage when the landlord sidebar is shown; on phones a
// menu button before the workspace name opens it.
const Header = ({ currentWorkspace = null, onOpenMenu }) => {
  const { workspaceId } = useParams();
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantContext = useContext(TenantContext);
  const {
    removeSharedProfile,
    loadSharedProfiles,
    shareProfile,
    SetIsSecWelcomePopup,
    fullProfileShared,
    fullProfileSharedLoaded,
  } = tenantContext;
  const {
    myApplications,
    shareApplicationWithLandlord,
    reloadApplications,
    landlordRequests,
    loadLandlordRequests,
  } = useContext(ApplicationContext);
  const [showModal, setShowModal] = useState(false);
  const [showInviteTenantModel, setShowInviteTenantModel] = useState(false);
  const _shareProfileParam =
    new URLSearchParams(window.location.search).get("shareprofilemodal") ===
    "true";
  const [isShareProfileModal, setIsShareProfileModal] =
    useState(_shareProfileParam);
  const [showShareProfileWelcomePopup, setShowShareProfileWelcomePopup] =
    useState(
      new URLSearchParams(window.location.search).get("welcome") === "true"
    );
  const [showRemove, setShowRemove] = useState(false);
  const [removeLandlordId, setRemoveLandlordId] = useState(null);
  const [currentLandlordPage, setCurrentLandlordPage] = useState(1);
  const [landlordsOrig, setAllLandlordsOrig] = useState([]);
  const [totalLandlordPage, setTotalLandlordPage] = useState(0);
  const [loading1, setLoading1] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [landlords, setAllLandlords] = useState([]);
  const [showSharedModal, setShowSharedModal] = useState(false);
  const [tempLandlord, setTempLandlord] = useState("");
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const isChangingLang = useRef(false);
  const lastUserLang = useRef(null);
  const [isLangChanging, setIsLangChanging] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const queryParam = new URLSearchParams(window.location.search);
  const shareWithEvent = queryParam.get("shareWith");
  const docuSignEvent = queryParam.get("event");
  const inviteTenantParam = queryParam.get("inviteTenant");
  const profile_type = queryParam.get("profile_type");
  const authContext = useContext(AuthContext);
  const { userType, user, logout, changeUserLng, notifications } = authContext;

  // Landlords waiting for this tenant's KYC-AML signature ("Signature pending"
  // in Share profile). Only loaded for tenants who have not signed.
  const identificationSigned =
    user?.consents?.client_identification_consent?.status ===
    constants.ACCEPTED;
  useEffect(() => {
    if (
      userType === "tenant" &&
      user?._id &&
      !identificationSigned &&
      !fullProfileSharedLoaded
    ) {
      loadSharedProfiles(user._id, "full").catch(() => {});
    }
  }, [userType, user?._id, identificationSigned, fullProfileSharedLoaded]);
  const signaturePendingCount = identificationSigned
    ? 0
    : (fullProfileShared ?? []).filter(
        (sharedProfile) =>
          sharedProfile?.landlord_client_identification ||
          sharedProfile?.application_id?.client_identification_required
      ).length;
  const shareProfileBadgeCount =
    (landlordRequests ?? []).length + signaturePendingCount;

  useEffect(() => {
    if (
      haveValue(user?.lang) &&
      user?.lang !== lastUserLang.current &&
      !isChangingLang.current
    ) {
      handleLanguageChange(user?.lang);
    }
  }, [user?.lang]);

  useEffect(() => {
    if (_shareProfileParam) {
      const url = new URL(window.location.href);
      url.searchParams.delete("shareprofilemodal");
      window.history.replaceState({}, "", url.toString());
    }

    const handlePopState = () => {
      if (
        new URLSearchParams(window.location.search).get("shareprofilemodal") ===
        "true"
      ) {
        setIsShareProfileModal(true);
        const url = new URL(window.location.href);
        url.searchParams.delete("shareprofilemodal");
        window.history.replaceState({}, "", url.toString());
      }
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("open-share-profile-modal", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("open-share-profile-modal", handlePopState);
    };
  }, []);

  const takeMeToProfile = () => {
    navigate(`/${userType}-profile`);
  };

  useEffect(() => {
    if (haveValue(inviteTenantParam) && inviteTenantParam) {
      setShowInviteTenantModel(true);
    }
  }, [inviteTenantParam]);

  useEffect(() => {
    var count = 0;
    if (notifications && notifications.length > 0) {
      notifications.forEach((val) => {
        if (val.marked_read == false) {
          count++;
        } else {
          return;
        }
      });
      setUnreadCount(count);
    }
  }, [notifications]);

  const [processingLandlordId, setProcessingLandlordId] = useState(null);

  const shareProfileFun = (
    userid,
    landlordid,
    profiletype,
    landlord,
    confirm = false
  ) => {
    //set confirm to true if londord is macc
    if (landlordid == process.env.REACT_APP_MACC_LANDLORED_ID) {
      confirm = true;
    }
    if (confirm) {
      setProcessingLandlordId(landlordid);
      shareProfile(userid, landlordid, "null", profiletype, {
        shareType: "shareBtn",
      })
        .then((res) => {
          if (res) setShowSharedModal(true);
          setTempLandlord(landlord);
          // loadLandlords();
          // loadSharedProfiles(user?._id, "full");
        })
        .catch((err) => {
          setShowSharedModal(false);
        })
        .finally(() => {
          setProcessingLandlordId(false);
        });
    }
  };

  const loadLandlords = async () => {
    setLoading1(true);
    const tenantid = localStorage.getItem("saveduserid");
    await axiosInstance
      .get(
        `${
          process.env.REACT_APP_SERVER_URL
        }/landlords/alllandlords?page=${currentLandlordPage}&limit=${2}&searchText=${searchText}&tenantid=${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        const temp = res.data.landlords;
        setTotalLandlordPage(res?.data?.totalPages);
        setAllLandlords(res.data.landlords);
        setAllLandlordsOrig(res.data.landlords);
        setLoading1(false);

        if (haveValue(shareWithEvent) && haveValue(docuSignEvent)) {
          const foundLL = temp.filter((val) => val._id == shareWithEvent);
          var userId = localStorage.getItem("saveduserid");
          if (docuSignEvent === "signing_complete") {
            shareProfileFun(userId, foundLL[0]?._id, "full", foundLL[0], true);
          } else if (docuSignEvent === "share_start") {
            shareProfileFun(userId, foundLL[0]?._id, "full", foundLL[0]);
          }
        }
      })
      .catch((err) => {
        setLoading1(false);
        console.log(err);
      });
    return true;
  };

  const [removeLandlordLoading, setRemoveLandlordLoading] = useState(false);

  // Stop sharing confirmation for an application (null for other cases)
  const [removeShareDetails, setRemoveShareDetails] = useState(null);

  const handleRemoveLandlord = async (sharedProfileId = removeLandlordId) => {
    if (haveValue(sharedProfileId)) {
      setRemoveLandlordLoading(true);
      removeSharedProfile(sharedProfileId)
        .then((res) => {
          if (res) {
            toast.success(_t("profileUnshared"));
            // loadLandlords();
            loadSharedProfiles(user?._id, "full", true);
            reloadApplications().catch(() => {});
            setShowRemove(false);
            setRemoveLandlordId(null);
            setRemoveShareDetails(null);
            setIsShareProfileModal(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setShowRemove(false);
          setRemoveShareDetails(null);
        })
        .finally(() => {
          setRemoveLandlordLoading(false);
        });
    }
  };

  // Application: confirmation listing everyone it applies to.
  // Individual profile: stops straight away (no confirmation).
  const handleStopSharing = (sharedProfileId, details = null) => {
    if (!details) {
      handleRemoveLandlord(sharedProfileId);
      return;
    }
    setRemoveShareDetails(details);
    setRemoveLandlordId(sharedProfileId);
    setShowRemove(true);
  };

  const handleLanguageChange = async (langVal) => {
    if (isChangingLang.current) return;
    isChangingLang.current = true;
    lastUserLang.current = langVal;
    setIsLangChanging(true);
    try {
      await i18next.changeLanguage(langVal);
      await changeUserLng();
      setCurrentLang(langVal);
    } finally {
      setTimeout(() => {
        isChangingLang.current = false;
        setIsLangChanging(false);
      }, 2000);
    }
  };

  const [isCreditModal, setIsCreditModal] = useState(false);

  return (
    <>
      <nav
        class={`navbar navbar-expand-lg navbar-light ${
          userType === "landlord" ? "position-fixed top-0" : "position-static"
        }`}
      >
        <div
          class={`container container-fluid ${
            userType === "landlord"
              ? "navbar-landlord-container navbar-container"
              : "navbar-container"
          }`}
        >
          <div className="row" style={{ alignItems: "center", width: "100%" }}>
            {userType === "landlord" ? (
              <div className="col-md-2 navbarLogoWrapper">
                {onOpenMenu && (
                  <RowButton
                    className="header-menu-button"
                    aria-label={_t("toggleSidebar")}
                    onClick={(e) => {
                      e.stopPropagation();
                      onOpenMenu();
                    }}
                  >
                    <Icon name="menu" size={20} />
                  </RowButton>
                )}
                <h4 className="header-workspace-name">
                  {location.pathname.includes("workspace-dashboard")
                    ? _t("allWorkspaces")
                    : currentWorkspace?.name}
                </h4>
              </div>
            ) : (
              <div className="col-auto navbarLogoWrapper me-md-4">
                <Link to="/">
                  <img
                    src={Logo}
                    alt="Skor Logo"
                    style={{ height: "2.024vw" }}
                  />
                </Link>
              </div>
            )}
            <div className="col hideOnMobile p-0">
              {!location.pathname.includes("workspace-dashboard") ? (
                <div
                  class="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  {userType === "landlord" && (
                    <NavTabs>
                      <NavTab
                        className="tutorial-tenant-tab"
                        to={`/${workspaceId}/profile-request`}
                        active={
                          location.pathname.includes("/profile-request") ||
                          (location.pathname?.includes("/profile-property") &&
                            profile_type !== "tenant_check")
                        }
                      >
                        {_t("tenantProfiles")}
                      </NavTab>
                      <NavTab
                        to={`/${workspaceId}/created-tenant`}
                        active={
                          location.pathname?.includes("/created-tenant") ||
                          (location.pathname?.includes("/profile-property") &&
                            profile_type === "tenant_check")
                        }
                      >
                        {_t("tenantChecks")}
                      </NavTab>
                      <NavTab
                        to={
                          user?.role === "landlord" && haveValue(workspaceId)
                            ? `/${workspaceId}/home`
                            : "/home"
                        }
                        active={location.pathname?.includes("/home")}
                      >
                        {_t("myProperties")}
                      </NavTab>
                      {user?.hasPaidRent && (
                        <NavTab
                          to={`/${workspaceId}/payment/property/list`}
                          active={location.pathname?.includes(
                            "/payment/property/list"
                          )}
                        >
                          {_t("propertiesPayments")}
                        </NavTab>
                      )}
                    </NavTabs>
                  )}
                  {userType === "tenant" && (
                    <NavTabs>
                      <NavTab to="/home" active={location.pathname === "/home"}>
                        {_t("skorReport")}
                      </NavTab>
                      <NavTab
                        to={
                          user?.rent_paid
                            ? `/tenant/review/rental`
                            : "/tenant/rentalStep"
                        }
                        active={
                          location.pathname === `/tenant/review/rental` ||
                          location.pathname === "/tenant/rentalStep"
                        }
                      >
                        {_t("PropertyPayments")}
                      </NavTab>
                      <div className="position-relative">
                        <NavTab
                          id="shareProfileLink"
                          onClick={() => setIsShareProfileModal(true)}
                          count={shareProfileBadgeCount}
                        >
                          {_t("shareProfile")}
                        </NavTab>
                        {showShareProfileWelcomePopup && (
                          <div className="welcome-popup share-profile-welcome-popup">
                            <div className="content-hover-div">
                              <img
                                src={Cancelimg}
                                alt=""
                                className="welcome-popup-close"
                                onClick={() => {
                                  setShowShareProfileWelcomePopup(false);
                                  SetIsSecWelcomePopup(true);
                                }}
                              />
                              <p className="text-break contentText">
                                {_t("shareProfileSectionPopupMessage")}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      <NavTab
                        to="/kelify"
                        active={location.pathname === "/kelify"}
                      >
                        {_t("kelify")}
                      </NavTab>
                    </NavTabs>
                  )}
                </div>
              ) : null}
            </div>
            <div className="col-md-5 d-flex language-switch-wrapper">
              {/* {userType === "landlord" &&
                (haveValue(user?.agency_id)
                  ? user?.agency_id?.self_serving
                  : user?.self_serving) && (
                  <div className="creditsScoreWrapper">
                    <div className="creditsScoreIcon d-flex align-items-center justify-content-center">
                      <img src="/images/credit-point1.svg" />
                    </div>
                    <p>
                      {_t("creditPts")}:{" "}
                      <span>
                        {haveValue(user?.agency_id)
                          ? user?.agency_id?.credits
                          : user?.credits ?? 0}
                      </span>
                    </p>

                    {(haveValue(user?.agency_id)
                      ? user?.agency_id?.self_serving
                      : user?.self_serving) && (
                      <div
                        className="creditsScoreIcon creditsScorePlus d-flex align-items-center justify-content-center"
                        style={{ background: "#A3EB64" }}
                        onClick={() => setIsCreditModal(true)}
                      >
                        <img src="/images/addGreen.svg" />
                      </div>
                    )}
                  </div>
                )} */}
              {userType === "landlord" &&
              user?.current_workspace?.self_serving &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div className="header-credits">
                  <img
                    className="header-credits__icon"
                    src="/images/credit-point1.svg"
                    alt=""
                  />
                  <p>
                    <strong>
                      {Number(
                        user?.current_workspace?.credits ?? 0
                      ).toLocaleString(i18next.language)}
                    </strong>{" "}
                    {_t("creditPts")}
                  </p>
                  {user?.current_workspace?.self_serving &&
                    WORKSPACE_ROLES_CAPABILITIES?.selfServing?.includes(
                      user?.current_workspace_role
                    ) && (
                      <Button
                        variant="accent"
                        size="sm"
                        iconOnly
                        aria-label={_t("buy")}
                        iconStart={<Icon name="plus" size={16} />}
                        onClick={() => setIsCreditModal(true)}
                      />
                    )}
                </div>
              ) : null}

              {/* {userType === "landlord" &&
              WORKSPACE_ROLES_CAPABILITIES?.tenants?.inviteTenant?.includes(
                user?.current_workspace_role,
              ) &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div className="shareQr hideOnMobile">
                  <a
                    className="btn btngreen invite_tenantbtn"
                    href={undefined}
                    onClick={(e) => setShowInviteTenantModel(true)}
                  >
                    <img
                      className="invite-tenant-icon"
                      src="/images/invite-tenant-icon.svg"
                      alt=""
                    />
                    {_t("requestProfile")}
                  </a>
                </div>
              ) : null} */}

              <div className="hideOnMobile">
                <LanguageSwitch
                  currentLang={currentLang}
                  isLangChanging={isLangChanging}
                  onChange={handleLanguageChange}
                />
              </div>
              {/* {userType === "landlord" && ( */}
              {(userType === "tenant" ||
                WORKSPACE_ROLES_CAPABILITIES?.viewNotifications?.includes(
                  user?.current_workspace_role
                )) &&
              !location.pathname.includes("workspace-dashboard") ? (
                <div className="header-bell hideOnMobile">
                  <Button
                    variant="secondary"
                    size="md"
                    iconOnly
                    aria-label={_t("notifications")}
                    iconStart={<Icon name="bell" />}
                    onClick={() =>
                      navigate(
                        haveValue(workspaceId)
                          ? `/${workspaceId}/notification`
                          : "/notification"
                      )
                    }
                  />
                  {unreadCount > 0 && (
                    <Badge tone="danger" className="header-bell__count">
                      {unreadCount > 99 ? "99+" : unreadCount}
                    </Badge>
                  )}
                </div>
              ) : (
                ""
              )}
              {/* )} */}
              <div className="slideryt">
                <div className="re-div">
                  <div className="dropdown admin-btn">
                    <RowButton
                      type="button"
                      className="header-account-button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-label={_t("myAccount")}
                    >
                      <Avatar name={getAccountName(user)} />
                      <Icon name="chevronDown" size={16} />
                    </RowButton>
                    <div className="dropdown-menu dropdown-menu-end ds-menu-host">
                      <Menu
                        avatar={<Avatar name={getAccountName(user)} />}
                        title={getAccountName(user)}
                        subtitle={user?.email}
                        items={[
                          ...(userType === "tenant"
                            ? [
                                {
                                  key: "edit",
                                  label: _t("editProfile"),
                                  icon: <Icon name="edit" size={18} />,
                                  onClick: () => navigate(`/edit-basic-info`),
                                },
                              ]
                            : []),
                          ...(userType === "landlord"
                            ? [
                                {
                                  key: "view",
                                  label: _t("viewProfile"),
                                  icon: <Icon name="eye" size={18} />,
                                  onClick: takeMeToProfile,
                                },
                                {
                                  key: "request",
                                  label: _t("requestProfile"),
                                  icon: <Icon name="send" size={18} />,
                                  className: "hideOnDesktop",
                                  onClick: () => setShowInviteTenantModel(true),
                                },
                              ]
                            : []),
                          {
                            key: "logout",
                            label: _t("logout"),
                            icon: <Icon name="logout" size={18} />,
                            danger: true,
                            onClick: () => setShowModal(true),
                          },
                        ]}
                        footerClassName="hideOnDesktop"
                        footer={
                          <div onClick={(e) => e.stopPropagation()}>
                            <LanguageSwitch
                              currentLang={currentLang}
                              isLangChanging={isLangChanging}
                              onChange={handleLanguageChange}
                            />
                          </div>
                        }
                      />
                    </div>
                  </div>
                </div>
                <DsModal
                  open={showModal}
                  onClose={() => setShowModal(false)}
                  size="sm"
                  title={_t("areYouSureYouWantToLogout")}
                  actions={
                    <>
                      <Button
                        variant="secondary"
                        size="lg"
                        onClick={() => setShowModal(false)}
                      >
                        {_t("cancel")}
                      </Button>
                      <Button variant="danger" size="lg" onClick={logout}>
                        {_t("logout")}
                      </Button>
                    </>
                  }
                />
                <InviteTenantModal
                  open={showInviteTenantModel}
                  onClose={() => setShowInviteTenantModel(false)}
                />
              </div>
            </div>
          </div>
        </div>
        <nav
          className="hideOnDesktop mobileTabs"
          aria-label={_t("menu", "Menu")}
        >
          {userType === "tenant" && (
            <>
              <MobileTab
                icon="fileText"
                label={_t("skorReport")}
                active={location.pathname === "/home"}
                onClick={() => navigate("/home")}
              />
              <MobileTab
                icon="send"
                label={_t("shareProfile")}
                count={shareProfileBadgeCount}
                onClick={() => setIsShareProfileModal(true)}
              />
            </>
          )}

          {userType === "landlord" && (
            <>
              <MobileTab
                icon="home"
                label={_t("myProperties")}
                active={location.pathname?.includes("/home")}
                onClick={() =>
                  navigate(
                    user?.role === "landlord" && haveValue(workspaceId)
                      ? `/${workspaceId}/home`
                      : "/home"
                  )
                }
              />
              <MobileTab
                icon="user"
                label={_t("tenantProfiles")}
                className="tutorial-tenant-tab"
                active={location.pathname.includes("/profile-request")}
                onClick={() => navigate(`/${workspaceId}/profile-request`)}
              />
              <MobileTab
                icon="shieldCheck"
                label={_t("tenantChecks")}
                active={location.pathname?.includes("/created-tenant")}
                onClick={() => navigate(`/${workspaceId}/created-tenant`)}
              />
              {user?.hasPaidRent && (
                <MobileTab
                  icon="wallet"
                  label={_t("propertiesPayments")}
                  active={location.pathname?.includes("/payment/property/list")}
                  onClick={() =>
                    navigate(`/${workspaceId}/payment/property/list`)
                  }
                />
              )}
            </>
          )}

          <MobileTab
            icon="bell"
            label={_t("notifications")}
            active={location.pathname?.includes("/notification")}
            onClick={() =>
              navigate(
                haveValue(workspaceId)
                  ? `/${workspaceId}/notification`
                  : "/notification"
              )
            }
          />
        </nav>
        {userType === "tenant" && (
          <ShareProfileModal
            isOpen={isShareProfileModal}
            onClose={() => setIsShareProfileModal(false)}
            loadLandlords={loadLandlords}
            setAllLandlords={setAllLandlords}
            setAllLandlordsOrig={setAllLandlordsOrig}
            landlordsOrig={landlordsOrig}
            searchText={searchText}
            setSearchText={setSearchText}
            loading1={loading1}
            landlords={landlords}
            setShowRemove={setShowRemove}
            shareProfileFun={shareProfileFun}
            setRemoveLandlordId={setRemoveLandlordId}
            onStopSharing={handleStopSharing}
            processingLandlordId={processingLandlordId}
            myApplications={myApplications}
            shareApplicationWithLandlord={shareApplicationWithLandlord}
          />
        )}
        {showRemove && removeShareDetails && (
          <StopSharingModal
            landlordName={removeShareDetails.landlordName}
            applicationTitle={removeShareDetails.applicationTitle}
            memberNames={removeShareDetails.memberNames}
            processing={removeLandlordLoading}
            onCancel={() => {
              setShowRemove(false);
              setRemoveLandlordId(null);
              setRemoveShareDetails(null);
              setIsShareProfileModal(true);
            }}
            onConfirm={() => handleRemoveLandlord()}
          />
        )}
        <Modal
          show={showRemove && !removeShareDetails}
          onHide={() => {
            setShowRemove(false);
            setRemoveLandlordId(null);
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui wrapper-modal"
        >
          <Modal.Header>
            <Modal.Title className="modal-type">
              {_t("areYouSureYouWantToStopSharingYourSkorProfile")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="btngroup row100 gridbar d-flex justify-content-between gap-3">
              <Button
                variant="outline"
                size="lg"
                type="button"
                onClick={(e) => {
                  setShowRemove(false);
                  setRemoveLandlordId(null);
                  setIsShareProfileModal(true);
                }}
              >
                {_t("cancel")}
              </Button>
              <Button
                variant="accent"
                size="lg"
                type="button"
                loading={removeLandlordLoading}
                onClick={handleRemoveLandlord}
              >
                {_t("remove")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={showSharedModal}
          onHide={() => {
            setShowSharedModal(false);
            setTempLandlord("");
            setIsShareProfileModal(true);
          }}
          centered
          className="newmodalui max-w-lg wrapper-modal newnaman"
        >
          <Modal.Body
            style={{ textAlign: "center" }}
            className="d-flex flex-column"
          >
            {_t("successYourSkorProfileHasBeenSuccessfullySharedWith")}{" "}
            {tempLandlord?.fname_companyName} {tempLandlord?.lname}.
            <Button
              size="lg"
              className="mx-auto mt-3"
              onClick={(e) => {
                setShowSharedModal(false);
                setTempLandlord("");
                setIsShareProfileModal(true);
              }}
            >
              {_t("goBack")}
            </Button>
          </Modal.Body>
        </Modal>
      </nav>
      <TopUpCreditModal
        open={isCreditModal}
        setOpen={() => setIsCreditModal(false)}
      />
    </>
  );
};

export default Header;
